import { useParams, useSearchParams } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import type { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { MAGAZINE_RESOURCE_ID_PARAMS, MAGAZINE_RESOURCE_TYPE_PARAMS } from "../../default/hooks/use-get-params";

import type { MAGAZINE_RESOURCE_TYPE } from "../../default/hooks/use-get-params";
import type { ParamParseKey } from "react-router";

type MagazinePageParams =
	| {
			hotelID: string;
			magazineResourceID: undefined;
			magazineResourceType: "AboutHotel";
			langCode: LangCode;
	  }
	| {
			hotelID: string;
			magazineResourceID: string;
			magazineResourceType: "Plan" | "Room";
			langCode: LangCode;
	  };

export const useGetMagazinePageParams = (): MagazinePageParams => {
	const { hotelID, langCode } = useParams<ParamParseKey<typeof PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.EDIT.I18N>>();
	const [searchParams] = useSearchParams();

	const magazineResourceID = searchParams.get(MAGAZINE_RESOURCE_ID_PARAMS);
	const magazineResourceType = searchParams.get(MAGAZINE_RESOURCE_TYPE_PARAMS) as MAGAZINE_RESOURCE_TYPE | null;

	if (!hotelID) {
		notifyUserEventInfo({
			title: "ホテルIDが取得できませんでした",
		});
	}

	if (!magazineResourceType || !langCode) {
		notifyUserEventInfo({
			title: "正しくないURLです",
		});
	}

	if (magazineResourceType === "AboutHotel") {
		return {
			hotelID: hotelID!,
			magazineResourceID: undefined,
			magazineResourceType,
			langCode: langCode! as LangCode,
		};
	}

	if (!magazineResourceID) {
		notifyUserEventInfo({
			title: "正しくないURLです",
		});
	}

	return {
		hotelID: hotelID!,
		magazineResourceID: magazineResourceID!,
		magazineResourceType: magazineResourceType!,
		langCode: langCode! as LangCode,
	};
};
